/**
 * generateTempPassword — Luna round-1 LOW-4 fix. The old implementation used
 * Math.random() (not cryptographically secure) for admin-issued temporary
 * passwords. This uses crypto.getRandomValues to build a >=16-char password
 * with guaranteed mixed character classes (word + lower/upper/digit/symbol).
 */
const WORDS = ['Anchor', 'Bolt', 'Crane', 'Girder', 'Hoist', 'Rig', 'Sling', 'Torque'];
const LOWER = 'abcdefghijkmnopqrstuvwxyz';
const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const DIGIT = '23456789';
const SYMBOL = '!@#$%^&*';
const ALL = LOWER + UPPER + DIGIT + SYMBOL;

function randomInt(maxExclusive: number): number {
  // Rejection sampling to avoid modulo bias.
  const limit = Math.floor(0xffffffff / maxExclusive) * maxExclusive;
  const buf = new Uint32Array(1);
  let v: number;
  do {
    crypto.getRandomValues(buf);
    v = buf[0];
  } while (v >= limit);
  return v % maxExclusive;
}

function randomChars(pool: string, count: number): string {
  let out = '';
  for (let i = 0; i < count; i += 1) out += pool[randomInt(pool.length)];
  return out;
}

export function generateTempPassword(): string {
  const word = WORDS[randomInt(WORDS.length)];
  // word + 12 random chars + one guaranteed char from each class → >= 16 chars.
  return `${word}-${randomChars(ALL, 11)}${randomChars(LOWER, 1)}${randomChars(UPPER, 1)}${randomChars(DIGIT, 1)}${randomChars(SYMBOL, 1)}`;
}